import { format } from 'date-fns';
import { MaleImage, FemaleImage } from "../utils/image";
import { apiUrl } from "../utils/apis";


const ImgUrl = apiUrl.imgUrl;

export const formatDMY = (dateString: string): string => {
  if (!dateString) return "-";

  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

 export const formatDate = (dateString?: string) => {
  if (!dateString) return "N/A";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "Invalid Date";

  return format(date, "MMMM d, yyyy, hh:mm a");
};
export const formatChatDate = (date: string) =>
  new Date(date).toLocaleDateString(undefined, {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
export const getStatusColor = (status: string ): string => {
  const colors: Record<string, string> = {
    pending: "#f59e0b",   // yellow
    completed: "#16a34a", // green
    rejected: "#dc2626",  // red
    cancelled: "#ef4444", // light red
    "in progress": "#3b82f6",
    approved: "#f4e006ff", // blue
  };

  return colors[status.toLowerCase()] || "#6b7280"; // default gray
};
export  const FormatTime = (timestamp) => {
  return new Date(timestamp).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const getCaseStatusColor = (status: string ): string => {
  const colors: Record<string, string> = {
    ongoing: "#f59e0b",   // yellow
    closed: "#16a34a", // green
    rejected: "#dc2626",  // red
    draft: "#3b82f6",
    approved: "#f4e006ff", // blue
  };

  return colors[status.toLowerCase()] || "#6b7280"; // default gray
};

export const getAvatar = (
  pic?: string,
  gender?: string
): string => {
  if (pic) {
    return `${pic}`;
  }

  if (gender === "M") {
    return MaleImage;
  }

  if (gender === "F") {
    return FemaleImage;
  }

  return MaleImage;
};


 export const statusColorMap:Record<string, string>  = {
  draft: "#3b82f6",     // blue
  ongoing: "#f59e0b",   // amber
  closed: "#22c55e",    // green
  rejected: "#ef4444",  // red
};

export const consultationStatusColorMap: Record<string, string> = {
  pending: "#f59e0b",        // amber
  completed: "#22c55e",      // green
  rejected: "#ef4444",       // red
  cancelled: "#f87171",      // light red
  "in progress": "#3b82f6",  // blue
  approved: "#84cc16",       // lime green
};

 export const getConsultationStatusColor = (status?: string) => {
  switch (status?.toLowerCase()) {
    case "pending":
      return "#f59e0b"; // yellow

    case "completed":
      return "#16a34a"; // green

    case "rejected":
      return "#dc2626"; // red

    case "cancelled":
      return "#ef4444"; // light red

    case "in progress":
      return "#3b82f6"; // blue

    case "approved":
      return "#f4e006ff"; // yellow

    default:
      return "#9e9e9e"; // gray fallback
  }
};




export const getSingleCaseStatusColor = (status: string): string => {
  switch (status.toLowerCase()) {
    case "ongoing":
      return "#f59e0b"; // yellow

    case "closed":
      return "#16a34a"; // green

    case "rejected":
      return "#dc2626"; // red

    case "draft":
      return "#3b82f6"; // blue

    case "approved":
      return "#f4e006ff"; // yellow (approved)

    default:
      return "#6b7280"; // gray fallback
  }
};


export const formatSaudiMobile = (mobile?: string | null): string => {
  if (!mobile) return '';

  let number = mobile.trim();

  // remove spaces and dashes
  number = number.replace(/[\s-]/g, '');

  // remove +966
  if (number.startsWith('+966')) {
    number = number.substring(4);
  }

  // remove 966
  if (number.startsWith('966')) {
    number = number.substring(3);
  }

  // remove leading 0
  if (number.startsWith('0')) {
    number = number.substring(1);
  }

  // must start with 5
  if (!number.startsWith('5')) {
    return mobile;
  }

  // must be 9 digits
  if (number.length !== 9) {
    return mobile;
  }

  return `+966${number}`;
};

export const normalizeEmail = (email?: string | null): string => {
  if (!email) return '';

  return email.trim().toLowerCase();
};

export const isValidPhoneNumber = (value?: string): boolean => {
  if (!value || typeof value !== 'string') {
    return false;
  }
}

export const isValidEmail = (value?: string): boolean => {
  if (!value || typeof value !== 'string') {
    return false;
  }

  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValid = regex.test(value.trim());

  return isValid;
};